import '@otto-ec/eprivacy-onetrust-styles'
import { bootstrap } from './bootstrap'

void bootstrap()
